// TODO This contains third-party code. Should investigate to see if this could be moved to bower instead and then extended in Glu
// Based upon Backbone-Nested 2.0.1 - Copyright (c) 2011-2012 Aidan Feldman (MIT License)
import $ from './$';
import util from './util';
import Model from './model';

const delayedTriggers = [];
let nestedChanges;

function getAttrPath(attrStrOrPath) {
  let path;

  if (util.isString(attrStrOrPath)) {
    // TODO this parsing can probably be more efficient
    path = (attrStrOrPath === '') ? [''] : attrStrOrPath.match(/[^\.\[\]]+/g);
    path = util.map(path, (val) => (
    // convert array accessors to numbers
      val.match(/^\d+$/) ? parseInt(val, 10) : val));
  } else {
    path = attrStrOrPath;
  }

  return path;
}

function createAttrStr(attrPath) {
  let attrStr = attrPath[0];
  util.each(util.rest(attrPath), (attr) => {
    attrStr += util.isNumber(attr) ? (`[${attr}]`) : (`.${attr}`);
  });

  return attrStr;
}

function deepClone(obj) {
  return $.extend(true, {}, obj);
}

function walkPath(obj, attrPath, callback, scope) {
  let val = obj;
  let childAttr;

  // walk through the child attributes
  for (let i = 0; i < attrPath.length; i++) {
    callback.call(scope || this, val, attrPath.slice(0, i + 1), attrPath[i + 1]);

    childAttr = attrPath[i];
    val = val[childAttr];
    if (!val) {
      // at the leaf
      break;
    }
  }
}

export default Model.extend({
  get(attrStrOrPath) {
    const attrPath = getAttrPath(attrStrOrPath);
    let result;

    walkPath(this.attributes, attrPath, (val, path) => {
      const attr = util.last(path);
      if (path.length === attrPath.length) {
        // attribute found
        result = val[attr];
      }
    });

    return result;
  },

  has(attr) {
    // for some reason this is not how Backbone.Model is implemented - it accesses the attributes object directly
    const result = this.get(attr);
    return !(result === null || util.isUndefined(result));
  },

  set(key, value, opts) {
    const newAttrs = deepClone(this.attributes);
    let attrPath;
    let unsetObj;
    let validated;

    if (util.isString(key)) {
      // Backbone 0.9.0+ syntax: `model.set(key, val)` - convert the key to an attribute path
      attrPath = getAttrPath(key);
    } else if (util.isArray(key)) {
      // attribute path
      attrPath = key;
    }

    if (attrPath) {
      opts = opts || {};
      this.setAttr(newAttrs, attrPath, value, opts);
    } else { // it's an Object
      opts = value || {};
      const attrs = key;
      for (const attrStr in attrs) {
        if (attrs.hasOwnProperty(attrStr)) {
          this.setAttr(
            newAttrs,
            getAttrPath(attrStr),
            opts.unset ? void 0 : attrs[attrStr],
            opts
          );
        }
      }
    }

    nestedChanges = Model.prototype.changedAttributes.call(this);

    if (opts.unset && attrPath && attrPath.length === 1) { // assume it is a singular attribute being unset
      // unsetting top-level attribute
      unsetObj = {};
      unsetObj[key] = void 0;
      nestedChanges = util.omit(nestedChanges, util.keys(unsetObj));
      validated = Model.prototype.set.call(this, unsetObj, opts);
    } else {
      unsetObj = newAttrs;

      // normal set(), or an unset of nested attribute
      if (opts.unset && attrPath) {
        // make sure Backbone.Model won't unset the top-level attribute
        opts = util.extend({}, opts);
        delete opts.unset;
      } else if (opts.unset && util.isObject(key)) {
        unsetObj = key;
      }
      nestedChanges = util.omit(nestedChanges, util.keys(unsetObj));
      validated = Model.prototype.set.call(this, unsetObj, opts);
    }


    if (!validated) {
      // reset changed attributes
      this.changed = {};
      nestedChanges = {};
      return false;
    }


    this.runDelayedTriggers();
    return this;
  },

  unset(attr, options) {
    return this.set(attr, void 0, util.extend({}, options, {
      unset: true
    }));
  },

  clear(options = {}) {
    nestedChanges = {};

    // Mostly taken from Backbone.Model.set, modified to work for NestedModel.
    const changed = {};
    this.changed = changed;
    const model = this;

    const setChanged = function (obj, prefix, setChangedOptions) {
      // obj will be an Array or an Object
      util.each(obj, (val, attr) => {
        let changedPath = prefix;
        if (util.isArray(obj)) {
          // assume there is a prefix
          changedPath += `[${attr}]`;
        } else if (prefix) {
          changedPath += `.${attr}`;
        } else {
          changedPath = attr;
        }

        val = obj[attr];
        if (util.isObject(val)) { // clear child attrs
          setChanged(val, changedPath, setChangedOptions);
        }
        if (!setChangedOptions.silent) {
          model.delayedChange(changedPath, null, setChangedOptions);
        }
        changed[changedPath] = null;
      });
    };
    setChanged(this.attributes, '', options);

    this.attributes = {};

    // Fire the `"change"` events.
    if (!options.silent) {
      this.delayedTrigger('change');
    }

    this.runDelayedTriggers();
    return this;
  },

  add(attrStr, value, opts) {
    const current = this.get(attrStr);
    if (!util.isArray(current)) {
      throw new Error('current value is not an array');
    }
    return this.set(`${attrStr}[${current.length}]`, value, opts);
  },

  remove(attrStr, opts) {
    opts = opts || {};

    const attrPath = getAttrPath(attrStr);
    const aryPath = util.initial(attrPath);
    const val = this.get(aryPath);
    const i = util.last(attrPath);

    if (!util.isArray(val)) {
      throw new Error('remove() must be called on a nested array');
    }

    // only trigger if an element is actually being removed
    const trigger = !opts.silent && (val.length >= i + 1);
    const oldEl = val[i];

    // remove the element from the array
    val.splice(i, 1);
    opts.silent = true; // Triggers should only be fired in trigger section below
    this.set(aryPath, val, opts);

    if (trigger) {
      attrStr = createAttrStr(aryPath);
      this.trigger(`remove:${attrStr}`, this, oldEl);
      for (let aryCount = aryPath.length; aryCount >= 1; aryCount--) {
        attrStr = createAttrStr(util.first(aryPath, aryCount));
        this.trigger(`change:${attrStr}`, this, oldEl);
      }
      this.trigger('change', this, oldEl);
    }

    return this;
  },

  changedAttributes(diff) {
    const backboneChanged = Model.prototype.changedAttributes.call(this, diff);
    if (util.isObject(backboneChanged)) {
      return util.extend({}, nestedChanges, backboneChanged);
    }
    return false;
  },

  toJSON() {
    return deepClone(this.attributes);
  },


  // private
  delayedTrigger(/* the trigger args */) {
    delayedTriggers.push(arguments);
  },

  delayedChange(attrStr, newVal, options) {
    this.delayedTrigger(`change:${attrStr}`, this, newVal, options);

    // Check if `change` even *exists*, as it won't when the model is
    // freshly created.
    if (!this.changed) {
      this.changed = {};
    }

    this.changed[attrStr] = newVal;
  },

  runDelayedTriggers() {
    while (delayedTriggers.length > 0) {
      this.trigger(...delayedTriggers.shift());
    }
  },

  // note: modifies `newAttrs`
  setAttr(newAttrs, attrPath, newValue, opts) {
    opts = opts || {};

    const fullPathLength = attrPath.length;
    const model = this;

    walkPath(newAttrs, attrPath, (val, path, next) => {
      const attr = util.last(path);
      const attrStr = createAttrStr(path);

      // See if this is a new value being set
      const isNewValue = !util.isEqual(val[attr], newValue);

      if (path.length === fullPathLength) {
        // reached the attribute to be set

        if (opts.unset) {
          // unset the value
          delete val[attr];

          // Trigger Remove Event if array being set to null
          if (util.isArray(val)) {
            const parentPath = createAttrStr(util.initial(attrPath));
            model.delayedTrigger(`remove:${parentPath}`, model, val[attr]);
          }
        } else {
          // Set the new value
          val[attr] = newValue;
        }

        // Trigger Change Event if new values are being set
        if (!opts.silent && util.isObject(newValue) && isNewValue) {
          const visited = [];
          const checkChanges = function (obj, prefix) {
            // Don't choke on circular references
            if (util.indexOf(visited, obj) > -1) {
              return;
            }
            visited.push(obj);


            let nestedAttr;
            let nestedVal;
            for (const a in obj) {
              if (obj.hasOwnProperty(a)) {
                nestedAttr = `${prefix}.${a}`;
                nestedVal = obj[a];
                if (!util.isEqual(model.get(nestedAttr), nestedVal)) {
                  model.delayedChange(nestedAttr, nestedVal, opts);
                }
                if (util.isObject(nestedVal)) {
                  checkChanges(nestedVal, nestedAttr);
                }
              }
            }
          };
          checkChanges(newValue, attrStr);
        }
      } else if (!val[attr]) {
        if (util.isNumber(next)) {
          val[attr] = [];
        } else {
          val[attr] = {};
        }
      }

      if (!opts.silent) {
        // let the superclass handle change events for top-level attributes
        if (path.length > 1 && isNewValue) {
          model.delayedChange(attrStr, val[attr], opts);
        }

        if (util.isArray(val[attr])) {
          model.delayedTrigger(`add:${attrStr}`, model, val[attr]);
        }
      }
    });
  }

});
